import { useTranslation } from 'react-i18next';
import { WifiOff, Loader2 } from 'lucide-react';
import { useOfflineSync } from '../../lib/hooks/useOfflineSync';

export default function OfflineBanner() {
  const { t } = useTranslation();
  const { isOnline, pendingCount, syncing } = useOfflineSync();

  if (isOnline && !syncing && pendingCount === 0) return null;

  if (isOnline && syncing) {
    return (
      <div className="bg-blue-600/90 text-white text-xs font-medium px-4 py-1.5 flex items-center justify-center gap-2 z-50">
        <Loader2 className="w-3.5 h-3.5 animate-spin" />
        <span>{t('common.syncing_pending', { count: pendingCount })}</span>
      </div>
    );
  }

  if (!isOnline) {
    return (
      <div className="bg-amber-100 dark:bg-amber-600/90 text-white text-xs font-medium px-4 py-1.5 flex items-center justify-center gap-2 z-50">
        <WifiOff className="w-3.5 h-3.5" />
        <span>
          {t('common.you_are_offline')}
          {pendingCount > 0 ? ` - ${t('common.actions_queued', { count: pendingCount })}` : ''}
        </span>
        <span className="mx-1.5 opacity-40">|</span>
        <span dir="rtl">{t('common.offline_ar')}</span>
      </div>
    );
  }

  return null;
}
